import { useCallback, useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled, { css } from 'styled-components';
import { Bookmark, IconProps } from 'react-feather';
import _ from 'lodash';

import { ticketUnaddressedSelector } from '@/redux/app/selectors/ticket';
import { setUnaddressed } from '@/redux/app/actions/ticket';
import { NavigationPaneRouteParamsContext } from '@/lib/navigation';

export interface TicketUnaddressedToggleProps {
  ticket: string;
}

export const TicketUnaddressedToggle = ({ ticket }: TicketUnaddressedToggleProps) => {
  const { subdomain } = useContext(NavigationPaneRouteParamsContext);
  const unaddressed = useSelector(_.partial(ticketUnaddressedSelector, ticket));
  const dispatch = useDispatch();
  const handleClick = useCallback((e) => {
    e.stopPropagation();
    dispatch(setUnaddressed(subdomain, ticket, !unaddressed));
  }, [unaddressed, subdomain, dispatch]);

  return (
    <TicketUnaddressedIcon
      unaddressed={unaddressed}
      tabIndex={0}
      role="button"
      aria-label="toggle addressed"
      size={22}
      onClick={handleClick}
      onKeyPress={handleClick}
      data-ticket-uuid={ticket}
      data-tip={unaddressed ? 'Mark Unaddressed' : 'Mark Addressed'}
    />
  );
};

export interface TicketUnaddressedIconProps extends IconProps {
  unaddressed: boolean;
}

export const TicketUnaddressedIcon = ({ unaddressed, ...props }: TicketUnaddressedIconProps) => (
  <BookmarkIcon
    $active={!!props.onClick}
    size={22}
    fill={unaddressed ? '#DD7019' : 'none'}
    strokeWidth={unaddressed ? '0px' : '2px'}
    {...props}
  />
);

const BookmarkIcon = styled(Bookmark)<{ active?: boolean }>`
  stroke: #BDBDBD;
  min-width: 20px;
  ${(props) => props.$active ? css`
    cursor: pointer;
    &:hover {
      stroke: #303030;
      border-color: #303030;
    }
  ` : ''}
`;